import { gsap } from 'gsap';
import { animation } from '../animations/home';
import { readGlobalState } from '../util/helpers';
import { mq } from '../util/matchMedia';

export const hero = (() => {
  const init = () => {
    mq.init();
    showRandomHeroImage();
    try {
      mq.mql.addEventListener('change', showRandomHeroImage);
    } catch(e) {
      mq.mql.addListener(showRandomHeroImage);
    }
    animation.init();
  };

  const showRandomHeroImage = () => {
    // Decide which images array to use (desktop or mobile)
    const breakpoint = readGlobalState('mq');
    const images = readGlobalState('hero')[breakpoint];

    if (images) {
      // Choose an image from that array at random
      const random = Math.floor(Math.random() * images.length);
      const imageData = images[random];

      // Create a new img element and append to DOM
      const imgElement = createImageElement(imageData, breakpoint);
      const container = document.querySelector('.js-home-bg-image');
      container.appendChild(imgElement);

      // Show new img element
      gsap.set(imgElement, { autoAlpha: 1 });
    }
  }

  const createImageElement = (data, breakpoint) => {
    const imgElement = document.createElement('img');
    imgElement.alt = data.alt;
    imgElement.width = data.width * 2;
    imgElement.height = data.height * 2;
    imgElement.src = data.src;
    imgElement.srcset = data.srcset || data.src;
    imgElement.sizes = 'auto';
    imgElement.classList.add('c-hero__image', `js-hero-image-${breakpoint}`);
    return imgElement;
  }

  return { init };
})();
